<template>
  <div  v-if="!loading">
    <van-image class="q_rank_bg" fit="cover" :src="require('../../assets/image/rank.png')"/>
    <!-- 队伍排行榜只需要里面那层van-tabs，将本div的'q_mar_t10px'改为'q_mar_t70px' -->
    <div class="q_mar_t10px">
      <van-tabs v-model="active1" @click="onChange">
        <van-tab title="服务时长">
          <div class="q_pad_tb10px">
            <van-tabs v-model="active" type="card" class="q_tab_card" @click="onClick">
              <van-tab title="当月榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('month',top2.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('month',top1.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.name }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('month',top3.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('month',item.userId)"
                       v-for="item,index in list" v-if="list.length>0">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="item.avatar"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>

                  <!--空数据-->
                  <div class="q_center" style="padding-top: 10vh;" v-if="list.length==0">
                    <img src="@/assets/image/none.png" style="width: 26vw;"/>
                    <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
                  </div>

                </div>
              </van-tab>
              <van-tab title="季度榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('quarter',top2.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('quarter',top1.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.name }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('quarter',top3.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('quarter',item.userId)"
                       v-for="item,index in list" v-if="list.length>0">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="item.avatar"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>
                  <!--空数据-->
                  <div class="q_center" style="padding-top: 10vh;" v-if="list.length==0">
                    <img src="@/assets/image/none.png" style="width: 26vw;"/>
                    <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
                  </div>

                </div>
              </van-tab>
              <van-tab title="年度榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('year',top2.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('year',top1.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.name }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('year',top3.userId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.avatar"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.name }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('year',item.userId)"
                       v-for="item,index in list" v-if="list.length>0">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="item.avatar"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>
                  <!--空数据-->
                  <div class="q_center" style="padding-top: 10vh;" v-if="list.length==0">
                    <img src="@/assets/image/none.png" style="width: 26vw;"/>
                    <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </van-tab>
        <!--活动积分-->
        <van-tab title="活动积分">

          <div class="q_ranktop" style="margin-top: -50vw;">
            <div class="q_rone" @click="GotoRankdeaIntrgral(userIntegralTop2.id)">
              <van-image class="q_crown" fit="cover"
                         :src="require('../../assets/image/two.png')"/>
              <van-image class="q_join_img" fit="cover"
                         :src="userIntegralTop2.avatar"/>
              <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ userIntegralTop2.realName }}
              </div>
              <div class="q_text_s q_mar_t5px q_color_white">{{ userIntegralTop2.integral + '积分' }}</div>
            </div>
            <div class="q_rtwo" @click="GotoRankdeaIntrgral(userIntegralTop1.id)">
              <van-image class="q_crown" fit="cover"
                         :src="require('../../assets/image/one.png')"/>
              <van-image class="q_join_img" fit="cover"
                         :src="userIntegralTop1.avatar"/>
              <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ userIntegralTop1.realName }}</div>
              <div class="q_text_s q_mar_t5px q_color_white">{{ userIntegralTop1.integral + '积分' }}</div>
            </div>
            <div class="q_rthree" @click="GotoRankdeaIntrgral(userIntegralTop3.id)">
              <van-image class="q_crown" fit="cover"
                         :src="require('../../assets/image/three.png')"/>
              <van-image class="q_join_img" fit="cover"
                         :src="userIntegralTop3.avatar"/>
              <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ userIntegralTop3.realName }}
              </div>
              <div class="q_text_s q_mar_t5px q_color_white">{{ userIntegralTop3.integral + '积分' }}</div>
            </div>
          </div>
          <div class="q_rank" style="margin-top: 81vw;">
            <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdeaIntrgral(item.id)"
                 v-for="item,index in userIntegralList" v-if="userIntegralList.length>0">
              <div class="q_inlineblock q_rnum q_center">
                <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
              </div>
              <div class="q_inlineblock q_mar_l10px">
                <van-image class="q_join_img" fit="cover"
                           :src="item.avatar"/>
              </div>
              <div class="q_mar_l15px q_inlineblock q_con">
                <div class="q_text_m q_bold q_moit2 q_justify">{{ item.realName }}</div>
              </div>
              <div class="q_inlineblock q_right q_time">
                <span class="q_text_s q_color_default q_bold">{{ item.integral + '积分' }}</span>
              </div>
            </div>
            <!--空数据-->
            <div class="q_center" style="padding-top: 10vh;" v-if="userIntegralList.length==0">
              <img src="@/assets/image/none.png" style="width: 26vw;"/>
              <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
            </div>
          </div>

        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {userActivityTimeUserMonth, userActivityTimeUserQuarter, userActivityTimeUserYear} from "@/api/userActivity";
import {getUserIntegralTop} from "@/api/integral";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Join',
  props: {
    msg: String
  },
  data() {
    return {
      loading:true,
      active1: 0,
      active: 0,
      top1: {},
      top2: {},
      top3: {},
      list: [],
      userIntegralTop1: {},
      userIntegralTop2: {},
      userIntegralTop3: {},
      userIntegralList: []
    }
  },
  created() {
    wxCloseShare()
    this.getMonth()
  },
  methods: {
    getMonth() {
      this.loading = true
      this.$modal.loading()
      // 获取当月
      userActivityTimeUserMonth().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    getQuarter() {
      this.loading = true
      this.$modal.loading()
      // 获取当月
      userActivityTimeUserQuarter().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    getYear() {
      this.loading = true
      this.$modal.loading()
      // 获取当月
      userActivityTimeUserYear().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    /**
     * 获取积分排行榜
     */
    getUserIntegralTop() {
      this.loading = true
      this.$modal.loading()
      getUserIntegralTop().then(res => {
        this.userIntegralTop1 = res.data[0]
        this.userIntegralTop2 = res.data[1]
        this.userIntegralTop3 = res.data[2]
        this.userIntegralList = []
        for (let i = 0; i < res.data.length; i++) {
          if (i > 2) {
            this.userIntegralList.push(res.data[i])
          }
        }
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    onClick(name, title) {
      if (title == '当月榜') {
        this.getMonth()
      }
      if (title == '季度榜') {
        this.getQuarter()
      }
      if (title == '年度榜') {
        this.getYear()
      }
    },
    GotoRankdea(type, userId) {
      this.$router.push({
        path: '/home/rankdeaPersonnel',
        query: {'type': type, 'userId': userId}
      });
    },
    GotoRankdeaIntrgral(userId) {
      this.$router.push({
        path: '/home/rankdeaIntegral',
        query: {'userId': userId}
      });
    },
    onChange() {
      if (this.active1 == 0) {
        // 服务时长排行
        this.getMonth()
      } else {
        // 积分排行
        this.getUserIntegralTop()
      }
    }
  },
}
</script>
<style scoped="scoped">
.q_join_img {
  width: 40px;
  height: 40px;
}

.q_join_img >>> .van-image__img {
  border-radius: 30px;
}

.q_con {
  width: 150px;
}

.q_time {
  width: 90px;
}

.q_rnum {
  width: 40px;
}

.q_rank {
  background-color: #ffffff;
  border-radius: 15px 15px 0 0;
  padding: 0 15px;
  margin-top: 255px;
}

.q_rank_bg {
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
}

>>> .van-tabs--card > .van-tabs__wrap {
  height: 40px;
}

>>> .van-tabs__nav {
  background-color: rgba(255, 255, 255, 0);
}

>>> .van-tab {
  color: rgba(255, 255, 255, .8);
}

>>> .van-tab--active {
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
}

>>> .van-tabs__line {
  height: 0;
}

.q_tab_card >>> .van-tabs__nav {
  background-color: rgba(255, 255, 255, .4);
  height: 40px;
  border-radius: 30px;
  border: none;
  margin: 0 40px;
}

.q_tab_card >>> .van-tabs__nav--card .van-tab.van-tab--active {
  color: #FF5733;
  font-weight: bold;
  background-color: #ffffff;
  font-size: 14px;
}

.q_tab_card >>> .van-tabs__nav--card .van-tab {
  color: #ffffff;
  border-right: 1px solid #ffffff;
  border-radius: 30px;
}

.q_ranktop {
  position: absolute;
  margin-top: -190px;
  width: 100%;
}

.q_ranktop .q_join_img {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  border: 2px solid rgba(255, 255, 255, .6);
}

.q_rone,
.q_rtwo,
.q_rthree {
  position: absolute;
  width: 105px;
  text-align: center;
}

.q_rone {
  top: 24px;
  left: 20px;
}

.q_rtwo {
  top: 0px;
  left: 135px;
}

.q_rthree {
  top: 40px;
  left: 250px;
}

.q_crown {
  position: absolute;
  top: -24px;
  left: 34px;
  width: 40px;
}
</style>
